<div class="grid">
	<div class="margin-bottom-20" dcrHTMLKey="RISK_PROXY_LIST_OVERVIEW_TEXT">
		Some of the products present in this portfolio need proxies in order to generate an analysis. Please review assigned proxies below and reach out to PAG team for any
		concerns.
	</div>
	<bfa-accordion>
		<ng-container *ngFor="let portfolio of portfolios">
			<accordion-panel [isCollapsed]="false">
				<header>{{ portfolio.id }}</header>
				<content>
					<hl-proxy-list class="proxy-list" [portfolio]="portfolio"></hl-proxy-list>
				</content>
			</accordion-panel>
		</ng-container>
	</bfa-accordion>
</div>
